<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <NewCustomers :items-per-page="5" />
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <PendingSamples :items-per-page="5" />
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <ReceivingSamples :items-per-page="5" />
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <SamplesWaitingForAnalysis :items-per-page="5" />
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
      <SamplesInAnalysis :items-per-page="5" />
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
      <AllPendingProducts :items-per-page="5" />
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
      <UnpaidCustomers :items-per-page="5" />
    </div>
  </div>
</template>
<script>
import UnpaidCustomers from '@views/admin/unpaidcustomers/view';
import PendingSamples from '@views/admin/samples/pendingsamples/view';
import ReceivingSamples from '@views/admin/samples/receivingsamples/view';
import NewCustomers from '@views/admin/customers/viewnewcustomers';
import SamplesInAnalysis from '@views/admin/samples/samplesinanalysis/view';
import AllPendingProducts from '@views/admin/products/viewpending';
import SamplesWaitingForAnalysis from '@views/admin/samples/waitingforanalysissamples/view';

export default {
  name: 'NurseDashboard',
  components: {
    UnpaidCustomers,
    PendingSamples,
    ReceivingSamples,
    NewCustomers,
    SamplesInAnalysis,
    AllPendingProducts,
    SamplesWaitingForAnalysis
  }
};
</script>
<style scoped>

</style>
